import { SearchInput, DateInput } from "react-admin";

const FilterCustomerPassportPhysical = [
  <SearchInput source="q" alwaysOn />,
  <DateInput source="date_withdrawal_init" label="Data de Entrega Inicial" />,
  <DateInput source="date_withdrawal_end" label="Data de Entrega Final" />
];

export default FilterCustomerPassportPhysical;
